export default __webpack_public_path__ + "static/media/logoMobile.1f05f6f3.png";